import { render, staticRenderFns } from "./PreviewPostWhatsapp.vue?vue&type=template&id=563c214c&scoped=true&"
import script from "./PreviewPostWhatsapp.vue?vue&type=script&lang=js&"
export * from "./PreviewPostWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPostWhatsapp.vue?vue&type=style&index=0&id=563c214c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563c214c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
